<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>SPECIES MANAGEMENT</h2>
          <p>List of species</p>
          <a (click)="backtomastermodule()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
            Back</a>
        </div>
      </div>
      <!---loader-->


      <!---loader-->
      <div class="row">

        <!--<div class="col-lg-4 col-sm-4 col-12">
     <div class="form-group">
     <div class="bd-example">
     <div class="input-group">
     <div class="custom-file">
     <input class="custom-file-input" id="inputGroupFile04species" (change)="onFileChange($event)" type="file">
     <label class="custom-file-label" for="inputGroupFile04species">Upload XLSX Data</label>
     </div>
     </div>
     </div>
     </div>
     </div>-->


        <div class="col-lg-5 col-sm-5 col-12">
          <div class="form-group">

            <!--   <button class="btn btn-primary mt-0 mb-0 download" (click)= "addspeciesmanagement()"><i class="fa fa-download"></i></button>
 -->
          </div>
        </div>
        <div class="col-lg-2 col-sm-2 col-12">
          <div [class.disablebutton]="isDisabled" class="form-group">

            <input class="custom-file-input" id="inputGroupFile04species" (change)="onFileChange($event)" type="file">
            <label class="custom-file-label" for="inputGroupFile04species">Upload XLSX Data</label>

          </div>
        </div>
        <div class="col-lg-1 col-sm-1 col-12">
          <div class="form-group">
            <button [disabled]="isDisabled" [class.disablebutton]="isDisabled" class="btn btn-primary mt-0 mb-0 add"
              (click)="addspeciesmanagement()"><i class="fa fa-plus" aria-hidden="true"></i><span
                class="lengthchange">Add</span></button>

          </div>
        </div>
        <div class="col-lg-1 col-sm-1 col-12">
          <div class="form-group">
            <button class="btn btn-primary mt-0 mb-0 download" (click)="exportspecies()"><i
                class="fa fa-download"></i></button>

          </div>
        </div>
        <div class="col-lg-3 col-sm-3 col-12">
          <div class="input-group filter_with_search form-group">
            <span class="input-group-btn">
              <button class="btn btn-default" type="button"><span class="fa fa-search"></span></button>
            </span>
            <input type="text" id="speciessearch" class="form-control" value="" name="x" placeholder="Search term...">
            <!--    <div class="input-group-btn search-panel" data-search="students">
             <button type="button" id="search_item"  class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
               <i class="fa fa-filter" aria-hidden="true"></i>
             </button>
             <ul class="dropdown-menu" role="menu">
               <li><a data-search="breed">Select By Species ID  </a></li>
               <li><a data-search="drug">Select By Family Name</a></li>
               <li><a data-search="disease">Select By Status</a></li>
               <li class="divider"></li>
             </ul>
         </div> -->
          </div>
        </div>



      </div>
      <!--<div id="loader"></div>-->

      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <!--loader start-->
          <div class="loading-div" *ngIf="isLoading">
            <div class="loading-bar">
              <div class="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <p class="mt-3">Processing data. Please wait..</p>
            </div>
          </div>
          <!--loader end-->
          <table id="myTable" class="row-border hover">

            <thead>
              <tr>
                <th>S.No</th>
                <th>Farm Name</th>
                <th>Species Name</th>
                <th>Species ID</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let speacieslist of getSpeaciesListData; index as j">
                <td>{{j + 1}}</td>
                <td>{{speacieslist.farm_name}}</td>
                <td>{{speacieslist.name}}</td>
                <td>{{speacieslist.speciesID}}</td>
                <td><span class="green" *ngIf="speacieslist.status==1">Active</span>
                  <span class="red" *ngIf="speacieslist.status==0">InActive</span>
                </td>
                <td>
                  <div class="nowrap">
                    <span><i id="{{speacieslist.id}}" (click)='viewspeciesmanagement($event)'
                        class="fa fa-file-text icon_common" aria-hidden="true"></i></span>
                    <span [class.disablebutton]="isDisabled"><i id="{{speacieslist.id}}"
                        (click)='editspeciesManagement($event)' class="fa fa-pencil-square-o icon_common edit"
                        aria-hidden="true"></i></span>
                    <ng-container *ngIf="speacieslist.can_delete==0">
                      <span [class.disablebutton]="isDisabled"><i id="{{speacieslist.id}}"
                          (click)=' sweetdelete($event)' class="fa fa-trash icon_common deletedata delete"
                          aria-hidden="true"></i> </span>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>